




























































import { Component } from "vue-property-decorator"
import {
    UPDATE_FORM_USER_NAME,
    UPDATE_FORM_USER_PASS,
    UPDATE_FORM_CHECK,
} from "@/store/types/mutations"
import {
    GET_FORM_USER_NAME,
    GET_FORM_USER_PASS,
    GET_FORM_CHECKED,
} from "@/store/types/getters"
import { signIn } from "@/store/types/actions"
import { Mutation, Getter, Action } from "vuex-class"
import { mixins } from "vue-class-component"

import NotifyMixin from "@/mixins/notify"

@Component
export default class Login extends mixins(NotifyMixin) {
    @Getter(GET_FORM_USER_NAME) private userName!: string | null
    @Getter(GET_FORM_USER_PASS) private userPass!: string | null
    @Getter(GET_FORM_CHECKED) private isChecked!: boolean

    @Mutation(UPDATE_FORM_USER_NAME) private updateFormUserName!: (
        payload: string
    ) => void
    @Mutation(UPDATE_FORM_USER_PASS) private updateFormUserPass!: (
        payload: string
    ) => void
    @Mutation(UPDATE_FORM_CHECK) private updateFormCheck!: (
        payload: boolean
    ) => void

    @Action(signIn) private signIn!: () => void
}
